import React, { useState, useEffect } from "react";
import { useLang } from "../context/LanguageContext";
import { Menu, X, Shield, Languages } from "lucide-react";

export default function Navbar() {
  const { t, toggle, lang } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (e, href) => {
    e.preventDefault();
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#0d2140]/95 backdrop-blur-md shadow-lg py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 flex items-center justify-between">
        <a href="#top" onClick={(e) => scrollTo(e, "#top")} className="flex items-center gap-2">
          <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-white/10 border border-white/15">
            <Shield className="w-5 h-5 text-[#f5871f]" />
          </span>
          <span className="font-display font-700 text-white text-xl tracking-wide">
            GRUPO <span className="text-[#f5871f]">RPC</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {t.nav.links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => scrollTo(e, l.href)}
              className="nav-link text-white/90 hover:text-white text-sm font-600 uppercase tracking-wider font-display"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={toggle}
            className="flex items-center gap-1.5 text-white/90 hover:text-white border border-white/25 rounded-full px-3 py-1.5 text-sm font-600 transition-colors hover:border-[#f5871f]"
            aria-label="Change language"
          >
            <Languages className="w-4 h-4" />
            {t.nav.langLabel}
          </button>

          <a
            href="#contacto"
            onClick={(e) => scrollTo(e, "#contacto")}
            className="btn-orange hidden sm:inline-flex items-center rounded-full px-5 py-2.5 text-sm font-700 uppercase tracking-wide font-display"
          >
            {t.nav.cta}
          </a>

          <button className="lg:hidden text-white" onClick={() => setOpen(!open)} aria-label="Menu">
            {open ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden mt-3 mx-4 rounded-2xl bg-[#0d2140] border border-white/10 p-5 shadow-2xl">
          <nav className="flex flex-col gap-1">
            {t.nav.links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => scrollTo(e, l.href)}
                className="text-white/90 hover:bg-white/5 rounded-lg px-3 py-3 text-base font-600 uppercase tracking-wide font-display"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contacto"
              onClick={(e) => scrollTo(e, "#contacto")}
              className="btn-orange mt-2 text-center rounded-full px-5 py-3 text-sm font-700 uppercase tracking-wide font-display"
            >
              {t.nav.cta}
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
